export default [
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('@/views/DashboardAdminView.vue'),
    meta: { requiresAuth: true, role: ['admin', 'user'] },
  },
]
